import { Checkbox } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import React from 'react';
import { useAction, useStakeholderReference } from '@hooks';
export const AlertChangeCheckbox = ({ stakeholderId }) => {
    const stakeholder = useStakeholderReference(stakeholderId);
    const update = useAction(coreActions.requestPatchCoreStakeholders);
    return (React.createElement(Checkbox, { checked: stakeholder.alertMetadataChanges, onChange: () => update({
            alertMetadataChanges: !stakeholder.alertMetadataChanges,
            stakeholderId
        }) }));
};
